import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { HomeService } from '../../home.service';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { SetupService } from '@core/services/setup';

@Component({
    selector: 'app-recent-news',
    templateUrl: './recent-news.component.html',
    styleUrls: ['./recent-news.component.scss'],
})
export class RecentNewsComponent implements OnInit {
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];
    loaded: boolean = false;

    icons = {
        arrowRight: faCaretRight,
    };

    newsTemplate: TemplateRef<any>;
    @ViewChild('newsOblique') template01: TemplateRef<any>;
    @ViewChild('newsSquared') template02: TemplateRef<any>;
    @ViewChild('newsEye') template03: TemplateRef<any>;

    constructor(
        private homeService: HomeService,
        public setupService: SetupService,
        private cdRef: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.lastNews();
    }

    ngAfterViewInit() {
        this.defineTemplate();
        this.cdRef.detectChanges();
        this.setupService.setFooterImage();
    }

    defineTemplate() {
        console.log(this.setupService.layout.components.lastnewsBlock);
        switch (this.setupService.layout.components.lastnewsBlock) {
            case '1':
                this.newsTemplate = this.template01;
                break;
            case '2':
                this.newsTemplate = this.template02;
                break;
            case '3':
                this.newsTemplate = this.template03;
                break;
            default:
                this.newsTemplate = this.template01;
                break;
        }
    }

    /**
     * lastNews() - Buscar últimas notícias publicadas
     */
    lastNews() {
        const limit = this.setupService.layout.components.lastnewsBlock === '3' ? 8 : 6;
        this.homeService.getLastNews(limit).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.loaded = true;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }
}
